/* eslint-disable */
const state = () => ({
    viewformid :  "",
    viewtemplateid: "",
    newversion:"",
    sourceTemplateId:"",
    newversionformid:"",
    selecteddesignformid:localStorage.getItem('selecteddesignformid'),
    versionhistorynote:"",
    versionid:"",
    latestversion:localStorage.getItem('selectedsetlatestversion'),
    visitName: "",
    siteCode: "",
    siteId: ""
   });
   
   const getters = {
    getlatestversion( state :{latestversion : any}){
        return state.latestversion;
        },
        getselecteddesignformid( state :{selecteddesignformid : any}){
        return state.selecteddesignformid;
        },
       getViewformid( state :{viewformid : any}){
           return state.viewformid;
       },
       getViewtemplateid( state :{viewtemplateid : any}){
            return state.viewtemplateid;
        },
        getnewversion( state :{newversion : any}){
            return state.newversion;
        },
        getversion( state :{versionid : any}){
            return state.versionid;
        },
        getsourceTemplateId( state :{sourceTemplateId : any}){
            return state.sourceTemplateId;
        },
        getnewversionformid( state :{newversionformid : any}){
            return state.newversionformid;
        },
        getversionhistorynote( state :{versionhistorynote : any}){
            return state.versionhistorynote;
        },
        getVisitName(state:{ visitName:any }){
            return state.visitName;
        },
        getSiteCode(state:{ siteCode:any }){
            return state.siteCode;
        },
        getSiteId(state:{ siteId:any }){
            return state.siteId;
        },
    };
   
   const actions ={
     async setlatestversion({commit} : any , data : any){
        commit("setlatestversion" , data);
    },
    async setselecteddesignformid({commit} : any , data : any){
        commit("setselecteddesignformid" , data);
    },
       async setViewformid({commit} : any , data : any){
           commit("setViewformid" , data);
       },
       async setViewtemplateid({commit} : any , data : any){
        commit("setViewtemplateid" , data);
       },
       async setnewversion({commit} : any , data : any){
        commit("setnewversion" , data);
       },
       async setversion({commit} : any , data : any){
        commit("setversion" , data);
       },
       async setsourceTemplateId({commit} : any , data : any){
        commit("setsourceTemplateId" , data);
       },
       async setnewversionformid({commit} : any , data : any){
        commit("setnewversionformid" , data);
       },
       async setversionhistorynote({commit} : any , data : any){
        commit("setversionhistorynote" , data);
       },
       async setVisitName({commit}:any, data:any){
        commit("setVisitName", data);
        },
       async setSiteCode({commit}:any, data:any){
    commit("setSiteCode", data);
        },
       async setSiteId({commit}:any, data:any){
    commit("setSiteId", data);
        },

   
   };
   
   const mutations ={
     setlatestversion(state : {latestversion : any } , selectedsetlatestversion : any ){
        state.latestversion = selectedsetlatestversion;
        localStorage.setItem("selectedsetlatestversion", selectedsetlatestversion);
    },
    setselecteddesignformid(state : {selecteddesignformid : any } , selecteddesignformData : any ){
        state.selecteddesignformid = selecteddesignformData;
        localStorage.setItem("selecteddesignformid", selecteddesignformData);
    },
        setViewformid(state : {viewformid : any } , formidData : any ){
           state.viewformid = formidData;
       },
       setViewtemplateid(state : {viewtemplateid : any } , templateidData : any ){
        state.viewtemplateid = templateidData;
       },
       setnewversion(state : {newversion : any } , newtemplateversion : any ){
        state.newversion = newtemplateversion;
       },
       setversion(state : {versionid : any } , templateversion : any ){
        state.versionid = templateversion;
       },
       setsourceTemplateId(state : {sourceTemplateId : any } , newsourcetemplateid : any ){
        state.sourceTemplateId = newsourcetemplateid;
       },
       setnewversionformid(state : {newversionformid : any } , sourcenewversionformid : any ){
        state.newversionformid = sourcenewversionformid;
       },
       setversionhistorynote(state : {versionhistorynote : any } , sourcehistorynote : any ){
        state.versionhistorynote = sourcehistorynote;
       },
       setVisitName(state:{visitName:any}, value:any){
       state.visitName = value;
       },

        setSiteCode(state:{siteCode:any}, value:any){
        state.siteCode = value;
        },

        setSiteId(state:{siteId:any}, value:any){
        state.siteId = value;
        },


   };
   
   export default {
       state,
       getters,
       actions,
       mutations
   }